import React from "react";
import PropTypes from "prop-types";
import { recordIdType } from "data/util/typedefs";
import HybridConfig from "lib/HybridConfig";
import Form from "lib/common/descriptorcontrols/Form/form";
import qs from "query_string";
import useFluxStore from "@armus/use-flux-store";
import userStore from "data/userStore";
import EntityName from "data/util/EntityName";

function item(key, label, type, control, config = {}) {
    return {
        config,
        key,
        id: key,
        path: key,
        label: label,
        disableBehaviour: "hide",
        type,
        control,
    };
}

function layout(control, label, childItems) {
    if (label instanceof Array) {
        childItems = label;
        label = "Unlabeled";
    }
    const l = item(
        Math.random().toString().substr(2),
        label,
        control === "form" ? "Form" : "Layout",
        control,
    );
    l.childItems = childItems;
    return l;
}

const FORM_DESCRIPTOR = layout("form", [
    item("textSize", "Font Size", "StringField", "dropdown", {
        options: ["Small", "Large"],
    }),
    item("columnCount", "Number of Data Columns", "StringField", "dropdown", {
        options: ["1", "2", "3"],
    }),
    item("labelWidth", "Field Name Column Width", "IntegerField", "spinner"),
    item("dataWidth", "Value Column Width", "IntegerField", "spinner"),
    layout("section", "Show", [
        item("showCellBorders", "Cell Borders", "ChoiceField", "checkbox"),
        item("showExportDate", "Print Date", "ChoiceField", "checkbox"),
        item("includeDisabledFields", "Disabled Fields", "ChoiceField", "checkbox"),
        item("includeUserHiddenFields", "Hidden Fields", "ChoiceField", "checkbox"),
        item("includeOffFormFields", "Off-Form Fields", "ChoiceField", "checkbox"),
        item("includeMissingValuedFields", "Missing Values", "ChoiceField", "checkbox"),
        item("showSectionFrames", "Frames", "ChoiceField", "checkbox"),
    ]),
    layout("section", "Mark", [
        item("markHarvestableFields", "Harvestable Fields", "ChoiceField", "checkbox"),
        item("markDisabledFields", "Disabled Fields", "ChoiceField", "checkbox"),
    ]),
]);

const initialState = {
    columnCount: "2",
    labelWidth: 200,
    dataWidth: 100,
    showCellBorders: true,
    showExportDate: true,
    showSectionFrames: true,
    textSize: "Large",
    includeOffFormFields: false,
    includeDisabledFields: true,
    includeMissingValuedFields: true,
    markDisabledFields: false,
    markHarvestableFields: false,
    includeUserHiddenFields: false,
};

function PrintDialog(props) {
    const {
        entityKey,
        id,
        onCancel,
    } = props;

    const org = userStore.getActiveOrgKey();
    const [state, setState] = React.useState(initialState);
    const [hideFeature, harvestFeature] = useFluxStore(
        () => {
            const implKey = new EntityName(entityKey).implKey;
            return [
                userStore.hasLicenseFeature("user-hidden-fields", implKey),
                userStore.hasLicenseFeature("harvestable-fields", implKey),
            ];
        },
        [
            userStore,
        ],
        [entityKey],
    );

    const handleCancel = (e) => {
        e.preventDefault();
        onCancel();
    };

    const handleChange = (desc, value) =>
        setState(s => ({
            ...s,
            [desc.key]: value,
        }));

    return <div className="print-dialog">
        <form action="#">
            <Form
                descriptor={FORM_DESCRIPTOR}
                propsResolver={it => ({
                    descriptor: it,
                    onCommitChange: handleChange,
                    value: state[it.key],
                    enabled: it.key === "includeUserHiddenFields"
                        ? hideFeature
                        : it.key === "markHarvestableFields"
                            ? harvestFeature
                            : true,
                })}
            />
        </form>
        <div className="modal-footer">
            <a
                className="btn btn-primary"
                href={`${HybridConfig.get("apiRoot")}export/${org}/pdf/export/${entityKey}/${id}.pdf?${qs.serialize(state)}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={onCancel}
            >
                Print
            </a>
            <button
                onClick={handleCancel}
                className="btn btn-secondary"
            >
                Cancel
            </button>
        </div>
    </div>;
}

PrintDialog.propTypes = {
    entityKey: PropTypes.string.isRequired,
    id: recordIdType.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default PrintDialog;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/print/PrintDialog.js